import React, { useState } from "react";

import { passwordStrength } from "check-password-strength";

import { changePassword } from "services";

import { incompleteMessage, setLocalKlimVar, useAppType, useNavigate, useParams, useToggleNavs, useTranslation } from "utils";

import { ErrorBoundary, Flex, Form, MainPage, ScreenSplit, Typography, Message as message } from "components";

import { PasswordResetButtons } from "pages/app/account/components/PasswordResetButtons";
import { PasswordResetInputs } from "pages/app/account/components/PasswordResetInputs";
import { TestimonialScreen } from "pages/app/account/components/TestimonialScreen";

interface PasswordResetFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export const PasswordReset = () => {
  const { t } = useTranslation(["signinup", "meta"]);
  const appType = useAppType();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  useToggleNavs(false, appType.mobile);

  const complete = (v: PasswordResetFormValues): void => {
    const passwordAnalysis = passwordStrength(v.password);
    if (v.password !== v.confirmPassword) {
      message({ content: t("password.notMatching"), icon: "error" });
    } else if (passwordAnalysis.contains.length < 3 || v.password.length < 6) {
      message({ content: t("profileUpdate.password.weak"), icon: "error" });
    } else {
      setLoading(true);
      const controller = new AbortController();

      changePassword({
        ...v,
        token: token || "",
        signal: controller.signal,
      })
        .then((res) => {
          setLocalKlimVar("token", res.token);
          navigate("/dashboard");
          message({ content: t("changePassword.changed"), icon: "tick" });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <ScreenSplit sideChildren={<TestimonialScreen farmerType="default" />}>
      <MainPage loading={loading} pageName={"sign-in-up"} containerClass={appType.mobile ? "small" : ""}>
        <section className="container">
          <Flex vertical gap={32} className="mini-form">
            <Flex vertical gap={8}>
              <Typography variant="h2">{t("changePassword.title")}</Typography>
              <Typography variant="paragraph-m">{t("changePassword.resetDescription")}</Typography>
            </Flex>
            <Form name="password" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
              <Flex vertical gap={32}>
                <ErrorBoundary>
                  <PasswordResetInputs />
                </ErrorBoundary>
                <ErrorBoundary>
                  <PasswordResetButtons loading={loading} />
                </ErrorBoundary>
              </Flex>
            </Form>
          </Flex>
        </section>
      </MainPage>
    </ScreenSplit>
  );
};
